import React from 'react';
import { Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colorPalette } from '@qualifio/ui-commons';
import { faSpotify } from '@fortawesome/free-brands-svg-icons/faSpotify';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { useTranslation } from 'react-i18next';

export function EmbeddedMediaWidgetSidebarAlert() {
  const { t } = useTranslation();

  return (
    <Box
      textAlign="left"
      sx={{
        fontSize: '12px',
        fontWeight: 400,
        color: colorPalette.grey.mainHover,
        margin: '10px',
      }}
    >
      {t('editor.embedded-media.modal.included-services')}

      <FontAwesomeIcon
        icon={faYoutube}
        color={colorPalette.red.main}
        style={{ marginLeft: '5px', marginRight: '5px' }}
      />
      <FontAwesomeIcon
        icon={faSpotify}
        color={colorPalette.green.dark}
        style={{ marginRight: '5px' }}
      />
      <br />
      <a
        href="https://support.qualifio.com/hc/en-us/articles/7384992405916"
        target="_blank"
        style={{ color: colorPalette.blue.main, fontSize: '12px', textDecoration: 'none' }}
        rel="noreferrer"
      >
        {t('editor.embedded-media.modal.link.support')}
      </a>
    </Box>
  );
}
